import React from 'react';
import s from './s.module.less';
import HeroSendFaxPreviewImg from '../imgs/hero-send-fax-preview.png';

const HeroSendFaxPreview = () => {
    return (
        <div className={s.root}>
            <img
                src={HeroSendFaxPreviewImg}
                className={s.image}
                alt="Send fax preview (illustration)"
            />
        </div>
    );
};

export default HeroSendFaxPreview;
